// String-union / const mirrors of the Prisma schema enums and platform session
// constants. Kept in sync with apps/platform/prisma/schema.prisma and
// apps/platform/core/session/types.ts by hand — update both sides together.

export type Client = "kiosk" | "flex" | "trade_in" | "webapp" | "pricing" | "remote_grader" | "sdk" | "vision_ai";

export type Step = "initialisation" | "start" | "identification" | "assessment" | "quote" | "transaction";

export type IdentifierType = "imei" | "serial_number";

export type IdentificationService = "i_free_i_cloud" | "esn" | "pandas_identify" | "external_catalogue";

// Tuple-backed so schemas can spread it into `z.enum([...])` without restating
// the members; the derived union stays identical to the Prisma enum.
export const DeviceTypes = ["smartphone", "smartwatch", "tablet"] as const;
export type DeviceType = (typeof DeviceTypes)[number];

export type ComponentType = "cosmetic" | "functional";

export type PandasCondition = "A" | "B" | "C" | "D";

export type SessionType = "trade_in" | "recycle" | "device_protection" | "repair" | "price_estimation";

export type PromoAmountType = "fixed" | "percentage";

export type ConditionPriceType = "percentage" | "fix";

export type VoucherStatus = "created" | "redeemed" | "canceled";

export enum VoucherType {
	create_voucher = "create_voucher",
}

export const CorePaymentMethod = "voucher";
export const EtisalatPaymentMethods = ["external_etisalat_smiles_points", "external_etisalat_money"] as const;
export const ComparecyclePaymentMethods = ["immediate_gift_card", "deferred_gift_card"] as const;
export const ExternalPaymentMethod = "external"; // generic payment method for external integrations

export const PaymentMethods = [
	CorePaymentMethod,
	...EtisalatPaymentMethods,
	...ComparecyclePaymentMethods,
	ExternalPaymentMethod,
	"unknown",
] as const;

export type PaymentMethod = (typeof PaymentMethods)[number];
